const nativeIsAvailable = () => {
    const testKey = 'localStorage_test_key';
    try {
        // When localStorage is not available these calls will fail returning false
        // localStorage cannot be available for a number of reasons;
        // - The users browser settings
        // - The app is loaded in an iframe, even though we don't support this
        // - The app is running in a private/incognito window
        localStorage.setItem(testKey, testKey);
        localStorage.removeItem(testKey);
        return true;
    } catch (e) {
        return false;
    }
};

// We use an IIFE(Immediately invoked function expression) so we can encapsulate the `storage` variable
const fakeLocalStorage = (function fakeStorageIIFE() {
    let storage = {};

    return {
        getItem: key => storage[key] || null,
        setItem: function (key, value) {
            storage[key] = value.toString();
        },
        removeItem: (key) => {
            delete storage[key];
        },
        clear: function () {
            storage = {};
        },
    };
})();

const safeLocalStorage = nativeIsAvailable() ? localStorage : fakeLocalStorage;
export default safeLocalStorage;
